import React, { useEffect, useState } from "react";
import { Star, Quote } from "lucide-react";
import { fetchReviews } from "../../lib/api";

export const Reviews = () => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    fetchReviews().then(setReviews).catch(() => {});
  }, []);

  return (
    <section className="py-12 sm:py-16" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <p className="uppercase tracking-[0.25em] text-xs font-semibold text-gold text-center">Loved across India</p>
        <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl tracking-tight font-medium text-charcoal mt-3 text-center">What Our Customers Say</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5 mt-8">
          {reviews.map((r) => (
            <div key={r.id} className="border border-gold/25 bg-ivory p-8 flex flex-col hover:border-gold/60 transition-colors" data-testid={`review-${r.id}`}>
              <Quote className="w-6 h-6 text-gold" strokeWidth={1.25} />
              <div className="flex gap-1 mt-4">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} className={`w-4 h-4 ${i < r.rating ? "fill-gold text-gold" : "text-gold/30"}`} />
                ))}
              </div>
              <p className="text-sm text-charcoal/70 leading-relaxed mt-4 flex-1">"{r.text}"</p>
              <div className="mt-6 pt-4 border-t border-gold/20 flex items-center gap-3">
                <span className="w-11 h-11 rounded-full bg-maroon text-ivory flex items-center justify-center font-heading text-sm tracking-wide ring-2 ring-gold/50 shrink-0" data-testid={`review-avatar-${r.id}`}>
                  {r.name.split(" ").map((w) => w[0]).join("")}
                </span>
                <span>
                  <span className="block font-heading text-base text-charcoal">{r.name}</span>
                  <span className="block text-xs text-charcoal/50 mt-0.5">{r.place} • purchased {r.product}</span>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
